import { Helmet } from 'react-helmet';
import { Provider as ReduxProvider } from 'react-redux';
import PropTypes from 'prop-types';
import { themes } from 'config/branding/themes';
import { darkColorCssVariables, lightColorSchemeCssVariables } from 'config/branding/themes/dark';
import { breakpoints } from '@activebrands/core-web/config/breakpoints';
import store from '@activebrands/core-web/state/store';
import CampaignSiteHandler from 'components/CampaignSiteHandler';
import ThirdPartyScripts from 'components/ThirdPartyScripts';

const DARK_MODE_ENABLED = process.env.REACT_APP_DARK_MODE_ENABLED === 'true';
const colorScheme = DARK_MODE_ENABLED ? 'light dark' : 'light';

const toCssDeclarations = variables =>
    Object.entries(variables)
        .map(([key, value]) => `${key}: ${value};`)
        .join('');

const RootElementWrapper = ({ element }) => (
    <ReduxProvider store={store}>
        <Helmet
            meta={[{ name: 'color-scheme', content: colorScheme }]}
            style={[
                {
                    'cssText': `
                            :root {               
                                color-scheme: ${colorScheme};

                                /* Theme variables */
                                --current-breakpoint: '${breakpoints[0].label}';
                                ${toCssDeclarations(themes.default.statics)}

                                /* @media (-ms-high-contrast: active) {
                                    Loop high-contrast theme variables here if you want a high-contrast theme
                                } */
                            }

                            ${
                                DARK_MODE_ENABLED
                                    ? `@media (prefers-color-scheme: dark) {
                                :root {
                                    ${toCssDeclarations(darkColorCssVariables)}
                                }

                                [data-color-scheme='light'] {
                                    color-scheme: light;
                                    ${toCssDeclarations(lightColorSchemeCssVariables)}
                                }
                            }`
                                    : ''
                            }
                            
                            ${breakpoints
                                .map(
                                    breakpoint =>
                                        `@media screen and (min-width: ${breakpoint.from}px) {
                                :root {
                                        --current-breakpoint: '${breakpoint.label}';
                                        ${toCssDeclarations(themes.default.responsives[breakpoint.label])}}}`
                                )
                                .join('')}    
                            
                        `,
                },
            ]}
        />
        <ThirdPartyScripts />
        <CampaignSiteHandler />
        {element}
    </ReduxProvider>
);

RootElementWrapper.propTypes = {
    element: PropTypes.node.isRequired,
};

export default RootElementWrapper;
